// Note: this only works if the enum (first arg) is defined with string values, not ordinals, e.g.: 'enum MyEnum { A = 'A' }'.
export const enumFromStringValue = <T>(enm: { [s: string]: T }, value: string | undefined): T | undefined => {
  // case-insensitive
  const values = (Object.values(enm) as unknown as string[]).map((v) => v.toLowerCase());
  if (values.includes(value?.toLowerCase() || '')) {
    return value as unknown as T;
  } else {
    console.error(`Value "${value}" is not a valid enum value of ${values}`);
    return undefined;
  }
};
